import GATSBY_COMPILED_MDX from "/opt/build/repo/src/content/learn/21-faq.mdx";
import * as React from "react";
import Layout from "../components/Layout";
import TableOfContents, {TableOfContentsIcon} from "../components/TableOfContents";
import {AspectRatio, Box, Container, Drawer, DrawerBody, DrawerCloseButton, DrawerContent, DrawerOverlay, Flex, Grid, GridItem, Heading, Stack, useDisclosure} from "@chakra-ui/react";
import {GatsbySeo} from "gatsby-plugin-next-seo";
import {NAV_HEIGHT_STYLES} from "../components/Nav";
export const SIDEBAR_OPACITY_ANIMATION_DURATION = 200;
const SIDEBAR_CONTENT_WIDTH = "280px";
const SIDEBAR_WIDTH = "330px";
const OPEN_BTN_TRANSLATE_X = "-100px";
function PageTemplate(_ref) {
  let {pageContext, data: {learnMdx, archMdx}, location, children} = _ref;
  const learnTocNodes = learnMdx.nodes;
  const archTocNodes = archMdx.nodes;
  const {title, description, videoId, videoTitle} = pageContext.frontmatter;
  const {isOpen, onOpen, onClose} = useDisclosure();
  const [sidebarOpen, setSidebarOpen] = React.useState(true);
  const [sidebarOpacity, setSidebarOpacity] = React.useState(1);
  const [sidebarContentWidth, setSidebarContentWidth] = React.useState(SIDEBAR_CONTENT_WIDTH);
  const [sidebarWidth, setSidebarWidth] = React.useState(SIDEBAR_WIDTH);
  const [openBtnTranslateX, setOpenBtnTranslateX] = React.useState(OPEN_BTN_TRANSLATE_X);
  function handleSidebarToggle() {
    var _window$gtag2, _window2;
    if (sidebarOpen) {
      var _window$gtag, _window;
      (_window$gtag = (_window = window).gtag) === null || _window$gtag === void 0 ? void 0 : _window$gtag.call(_window, "event", "collapse_toc");
      setSidebarOpacity(0);
      setTimeout(() => {
        setSidebarContentWidth("0");
        setSidebarWidth("0");
        setSidebarOpen(false);
        setOpenBtnTranslateX("0px");
      }, SIDEBAR_OPACITY_ANIMATION_DURATION - 100);
      return;
    }
    (_window$gtag2 = (_window2 = window).gtag) === null || _window$gtag2 === void 0 ? void 0 : _window$gtag2.call(_window2, "event", "expand_toc");
    setSidebarOpen(true);
    setSidebarContentWidth(SIDEBAR_CONTENT_WIDTH);
    setSidebarWidth(SIDEBAR_WIDTH);
    setOpenBtnTranslateX(OPEN_BTN_TRANSLATE_X);
    setTimeout(() => {
      setSidebarOpacity(1);
    }, SIDEBAR_OPACITY_ANIMATION_DURATION);
  }
  return React.createElement(React.Fragment, null, React.createElement(GatsbySeo, {
    title: "Learn GraphQL: " + title || "Learn GraphQL",
    description: description || "Explore these topics to build a solid understanding of core GraphQL concepts like schemas, types, and queries."
  }), React.createElement(Layout, null, React.createElement(Grid, {
    display: {
      base: "block",
      lg: "flex"
    },
    templateColumns: {
      base: "1fr",
      lg: "1fr 3fr"
    },
    gap: 0
  }, React.createElement(GridItem, {
    display: {
      base: "none",
      lg: "block"
    },
    position: "sticky",
    transition: "linear " + SIDEBAR_OPACITY_ANIMATION_DURATION + "ms width",
    alignSelf: "start",
    id: "toc-nav",
    top: 70,
    w: sidebarWidth
  }, React.createElement(Stack, {
    spacing: 4,
    height: "90vh",
    alignItems: "center",
    overflow: "scroll"
  }, React.createElement(Flex, {
    p: "10",
    alignItems: "flex-start"
  }, React.createElement(TableOfContents, {
    opacity: sidebarOpacity,
    width: sidebarContentWidth,
    pathname: location.pathname,
    items: {
      learnTocNodes,
      archTocNodes
    }
  }), React.createElement(TableOfContentsIcon, {
    pos: "absolute",
    right: "20px",
    display: {
      base: "none",
      lg: "block"
    },
    transform: "rotate(" + (sidebarOpen ? "0deg" : "180deg") + ")",
    transitionDelay: SIDEBAR_OPACITY_ANIMATION_DURATION + "ms",
    onClick: () => {
      handleSidebarToggle();
    }
  })))), React.createElement(GridItem, {
    flexGrow: 1,
    borderStyle: "solid",
    borderWidth: "0 0 0 1px",
    borderColor: "silver.400",
    w: {
      base: "100%",
      lg: "70%"
    }
  }, title && React.createElement(Box, {
    position: "sticky",
    top: NAV_HEIGHT_STYLES,
    p: "6",
    borderStyle: "solid",
    borderWidth: "0 0 1px 0",
    borderColor: "silver.400",
    bg: "#fff",
    zIndex: 1,
    textAlign: {
      base: "center",
      lg: "center",
      "2xl": "center"
    },
    display: {
      base: "flex",
      lg: "block"
    },
    justifyContent: "center",
    alignItems: "center"
  }, React.createElement(Heading, {
    as: "h1",
    color: "blue.900"
  }, title), React.createElement(TableOfContentsIcon, {
    display: {
      base: "block",
      lg: "none"
    },
    ml: "4",
    onClick: onOpen
  }), React.createElement(Box, {
    pos: "fixed",
    left: "20px",
    top: "112px",
    transition: "ease-in-out 200ms all",
    transform: "translateX(" + openBtnTranslateX + ")"
  }, React.createElement(TableOfContentsIcon, {
    display: {
      base: "none",
      lg: "block"
    },
    transform: "rotate(180deg)",
    onClick: () => {
      handleSidebarToggle();
    }
  }))), React.createElement(Container, {
    py: "32px",
    px: "40px",
    maxW: "6xl"
  }, React.createElement(Stack, {
    spacing: "24px"
  }, videoId && React.createElement(Box, {
    align: "center"
  }, React.createElement(AspectRatio, {
    ratio: 16 / 9,
    py: "32px",
    maxWidth: "800"
  }, React.createElement("iframe", {
    title: videoTitle,
    src: "https://www.youtube.com/embed/" + videoId,
    allowFullScreen: true
  }))), children)))), React.createElement(Drawer, {
    isOpen: isOpen,
    placement: "right",
    onClose: onClose
  }, React.createElement(DrawerOverlay, null), React.createElement(DrawerContent, null, React.createElement(DrawerCloseButton, null), React.createElement(DrawerBody, null, React.createElement(TableOfContents, {
    pathname: location.pathname,
    items: {
      learnTocNodes,
      archTocNodes
    }
  }))))));
}
export default function GatsbyMDXWrapper(props) {
  return React.createElement(PageTemplate, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
const pageQuery = "2247166434";
export const Head = _ref2 => {
  let {pageContext} = _ref2;
  return React.createElement("title", null, pageContext.frontmatter.title, " - GraphQL.com");
};
